import styled from '@emotion/styled'
import { css } from '@emotion/core'

import Button from 'portal-modules/common/components/Button'
import { getEmbeddedViewFlag } from 'portal-modules/common/utils/get-embedded-flag'

export const StyledButton = styled(Button)`
  margin: 8px 8px 8px 0;
`

export const StyledH4 = styled('h4')`
  color: ${({ theme }) => getEmbeddedViewFlag() ? theme.primary.base : theme.text.dark};
  font-size: 18px;
  font-weight: normal;
  line-height: 1.5;
  margin: 0;
`

const baseP = css`
  font-size: 13px;
  font-weight: 300;
`

export const StyledDetailWrapper = styled('div')`
  padding-top: 16px;
`

export const StyledDetailsP = styled('p')`
  ${baseP};
  margin: 0;

  ${({ theme }) => {
    const textColor = getEmbeddedViewFlag() ? theme.secondary.base : theme.text.light;
    return `
      span, strong {
        color: ${textColor};
        font-style: italic;
      }
    `;
  }}

  strong {
    font-weight: bold;
  }
`;

export const StyledDetailsH5 = StyledDetailsP.withComponent('h5')

export const StyledFooterP = styled('p')`
  ${baseP};
  display: flex;
  flex-direction: ${props => (props.showCardDetails ? 'row' : 'column')};
  justify-content: space-between;
  margin: 0;

  ${({ type }) =>
    (type === 'split') &&
    `
      width: 100%;
    `}
`

export const StyledSection = styled('section')`
  h5 {
    margin: 0;
  }
`

export const StyledDetailsDiv = styled('div')`
  display: flex;
  justify-content: space-between;

  :first-child p {
    margin-bottom: ${({ noMargin }) => (noMargin ? '0' : '8px')};
  }

  :last-child p {
    margin: 0;
  }
`

export const StyledMaxPayment = styled('span')`
   font-size: 13px;
   font-weight: 300;
   color: ${({ theme }) => getEmbeddedViewFlag() ? theme.secondary.base : theme.text.light};
    font-style: italic;
`

export const StyledBold = styled('p')`
  font-weight: bold;
  font-style: italic;
  margin: 0;
  color: ${({ theme }) => theme.text.light};
`

export const StyledDetailsBiMonthlySection = styled('section')`
display: flex;
flex-direction: column;
align-items: flex-start;
gap: 16px;
flex: 1 0 0;
`

export const StyledDetailsBiMonthlyCardContainer = styled('div')`
display: flex;
align-items: flex-start;
gap: 16px;
align-self: stretch;
`

export const StyledDetailsSplitSection = styled(StyledDetailsBiMonthlyCardContainer)``
export const StyledDetailSplitCardContainer = styled(StyledDetailsBiMonthlyCardContainer)``
